// extracted by mini-css-extract-plugin
export default {"modal":"CP-z","error":"DP-z","disabled":"EP-z","fields":"FP-z","errorMsg":"GP-z","footer":"HP-z","formContentWrapper":"IP-z","productImage":"JP-z","overlay":"KP-z"};